import {v1_PaymentCompanies_select_column} from '../../generated/types';

const PaymentCompanies = {
    ...v1_PaymentCompanies_select_column,
    res: 'v1_PaymentCompanies',
    comp: {},
    rel: {},
};

export default PaymentCompanies;
